(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairSponsorController', PhysicalFairSponsorController);
    PhysicalFairSponsorController.$inject = ['ExpoService', 'PhysicalFairService'];
    function PhysicalFairSponsorController(ExpoService, PhysicalFairService) {
        var vm = this;

        vm.flag                  = false;
        vm.expoSelected          = '';
        vm.selectExpo            = selectExpo;
        vm.getByFilter           = getByFilter;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                 vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {

            vm.queryFlag = false;
            vm.query = {};
            vm.query['page']    = vm.page;
            if(vm.expoSelected !== '') {
                vm.query['expo_id'] = vm.expoSelected;
            }
            PhysicalFairService.getSponsors(vm.query).then(function(response){
                vm.queryFlag        = true;
                vm.sponsors         = response.data.data;
                vm.totalItems       = response.data.total;
                vm.itemsPerPage     = response.data.per_page;
                vm.setPage(response.data.current_page);

            }).catch(function(err){
            });
        }
        activate();
    }
})();